import { getItems } from 'common/api/panels';

import {
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default ({
        orderBy,
        page = 0,
        pageSize,
        searchText,
        sortBy,
        status,
    } = {}) =>
    (dispatch) => {
        dispatch(actions[FETCH_ITEMS]());

        getItems({
            orderBy,
            page: page + 1,
            perPage: pageSize,
            searchText,
            sortBy,
            status,
        })
            .then((response) =>
                dispatch(actions[FETCH_ITEMS_SUCCESS](response.data)),
            )
            .catch((error) =>
                dispatch(
                    actions[FETCH_ITEMS_FAILURE](error?.response?.data?.errors),
                ),
            );
    };
